<template>
	<Disclosure :title="$t('text.accountingInfoTitle')" data-cy="accountingInfo" ref="SECTION_accountingInfo">
		<div class="field left-border">
			<v-label>{{$t('text.erpContractorId')}}</v-label>
			<v-text-field variant="outlined" density="compact"
				v-model="model.de"
				:error-messages="erpContractorIdErrors"
				:hide-details="!erpContractorIdErrors.length"
				@update:modelValue="onUpdateModel"
				@blur="validateAllFields"
			/>
			<p class="helpText" v-html="$t('text.erpContractorIdHelpText')"/>
		</div>
	</Disclosure>
</template>

<script>
import Disclosure from '@/components/common/Disclosure.vue'
import { isValidErpId } from '../../../../shared/erp-id'

export default {
	name: 'AccountingInfo',
	components: {
		Disclosure
	},
	props: {
		modelValue: Object,
	},
	data: () => ({
		model: { de: '' },
		initialValue: null,
		erpContractorIdErrors: [],
	}),
	watch: {
		modelValue() {
			this.initModel()
		},
	},
	methods: {
		sendData() {
			return {
				erpContractorId: { de: this.model.de },
			}
		},
		onUpdateModel() {
			this.validateAllFields()
			this.$emit('change', this.model.de !== this.initialValue)
		},
		// MYS-7387: PEAK stores the ERP contractor id as INT and rejects anything else
		validateAllFields() {
			this.erpContractorIdErrors = isValidErpId(this.model.de) ? [] : [this.$t('text.fieldValErpContractorIdFormat')]
			return this.erpContractorIdErrors.length === 0
		},
		initModel() {
			// modelValue might not be available upon created(), initModel will be triggered again from watch
			if (!this.modelValue) return
			// init model only once
			if (this.initialValue !== null) return

			this.initialValue = this.modelValue.de ?? ''
			this.model = { de: this.initialValue }
		},
	},
	created() {
		this.initModel()
	},
}
</script>

<style scoped>
</style>
